// Types
import { UploadIdDifferentDataCustomerApiResponseType } from '../../types/upload-id-different-data-customer-api-response.type';

const customerDataFromOCRIsValid = (
  response: UploadIdDifferentDataCustomerApiResponseType
): boolean => Boolean(response?.birthDate && response?.nationality && response?.fullName);

export { customerDataFromOCRIsValid };
